import { render, staticRenderFns } from "./ttshop_addinvoice.vue?vue&type=template&id=7a8f113f&scoped=true&"
import script from "./ttshop_addinvoice.vue?vue&type=script&lang=js&"
export * from "./ttshop_addinvoice.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_addinvoice.vue?vue&type=style&index=0&id=7a8f113f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8f113f",
  null
  
)

export default component.exports